import { render } from "./ProfessionsForeignAmountsView.vue?vue&type=template&id=634ef4ea&scoped=true"
import script from "./ProfessionsForeignAmountsView.vue?vue&type=script&lang=js"
export * from "./ProfessionsForeignAmountsView.vue?vue&type=script&lang=js"

import "./ProfessionsForeignAmountsView.vue?vue&type=style&index=0&id=634ef4ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634ef4ea"]])

export default __exports__